/**
 * Versão da aplicação — incrementar a cada build significativo.
 *
 * Convenção Semantic Versioning:
 *   MAJOR.MINOR.PATCH
 *     - MAJOR: mudança estrutural (schema, refactoring pesado)
 *     - MINOR: novas features
 *     - PATCH: bugfixes / UX polish
 */
export const APP_VERSION = "3.15.10";
